var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec" },
      [
        _c(
          "div",
          {
            staticClass:
              "loop_container bg-transparent update-request-form-common"
          },
          [
            _c("div", { staticClass: "card form-wrapper" }, [
              _vm.hasData
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 text-center" }, [
                      _vm.logoURL
                        ? _c("img", {
                            staticClass: "top-logo custom-logo",
                            attrs: {
                              src: _vm.logoURL,
                              alt:
                                "Community Logo of " +
                                _vm.community.content.parameter4
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "not-found",
                  staticStyle: { "text-align": "center", padding: "2rem" }
                },
                [
                  _c("h1", [_vm._v("404")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Sorry, we couldn't find that page.")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.landingUrl,
                        target: "_self",
                        rel: "noopener noreferrer"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Go back" +
                          _vm._s(
                            _vm.communityName ? " to " + _vm.communityName : ""
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.hasData
              ? _c("footer", [
                  _c(
                    "ul",
                    { staticClass: "list-inline text-center footer-links" },
                    [
                      _c("li", [
                        _vm.community.content &&
                        _vm.community.content.landingPageURL &&
                        _vm.community.content.landingPageURL.length
                          ? _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: {
                                  href: _vm.community.content.landingPageURL,
                                  target: "_blank",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Learn More")]
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Learn More")]
                            )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm.community.content &&
                        _vm.community.content.termsConditionsURL &&
                        _vm.community.content.termsConditionsURL.length
                          ? _c(
                              "a",
                              {
                                staticClass: "links",
                                attrs: {
                                  href:
                                    _vm.community.content.termsConditionsURL,
                                  target: "_blank",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Terms Of Use [pdf]")]
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  tabindex: "0"
                                }
                              },
                              [_vm._v("Terms Of Use [pdf]")]
                            )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "unsubscribe-community-logo" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.protopia.co",
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            tabindex: "0",
                            src: _vm.footerLogoURL,
                            alt:
                              "Community Logo of " +
                              _vm.community.content.parameter4
                          }
                        }),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(
                            "Protopia\n                            - Visit our site"
                          )
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a86191f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a86191f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 